import * as types from '../../constants/constants';

export const sendOtpRequest = (payload) => ({
    type: types.SEND_OTP_REQUEST,
    payload,
  });
  
  export const sendOtpSuccess = (data) => ({
    type: types.SEND_OTP_SUCCESS,
    payload: data,
  });
  
  export const sendOtpFailure = (error) => ({
    type: types.SEND_OTP_FAILURE,
    payload: error,
  });